import { Component, Inject, Input } from '@angular/core';
import { ApplicationFacade, Itinerary } from '@ridango/components';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-leg-origin',
    templateUrl: './leg-origin.component.html'
})
export class LegOriginComponent {
    @Input() time: number;
    @Input() itinerary: Itinerary;
    @Input() delay: number;
    @Input() legName: string;
    assetsPath$ = this.applicationFacade.assetsPath$;

    constructor(
        private applicationFacade: ApplicationFacade,
        @Inject('ENV') public env: Env
    ) {}

    public get realdataStartTime(): number {
        return this.itinerary?.startTime + (this.itinerary?.journeyStartDepartureDelay || 0) * 1000;
    }

    public get isDelayed(): boolean {
        const tresholdEarly = -this.env.JOURNEY_PLANNER?.SCHEDULE_TIME_THRESHOLD_EARLY;
        const tresholdLate = this.env.JOURNEY_PLANNER?.SCHEDULE_TIME_THRESHOLD_LATE;
        const timeDifference =
            (this.realdataStartTime - (this.time - this.itinerary.journeyStartDepartureDelay * 1000)) / 1000 / 60;
        return tresholdEarly || tresholdLate
            ? Math.floor(timeDifference) > tresholdLate || Math.ceil(timeDifference) < tresholdEarly
            : !!this.delay;
    }
}
